import { Log, useUBL } from '@common/log-manager';
import { getServerLogForVerticalProductCard, UxGoodsCardItemForVerticalProductCard } from '@common/product-card';

interface UseProductCardUBLOptions {
  original_product_id: string;
  selectedDrLogMap: Record<string, string> | null;
}

export function useProductCardUBL(options: UseProductCardUBLOptions) {
  const { original_product_id, selectedDrLogMap } = options;

  const sendUbl = useUBL();

  const parentUbl: Omit<Log, 'category'> = {
    navigation: 'product_detail',
    object_type: 'catalog',
    object_section: 'infinite_scroll_item_list',
  };

  const getChildUbl = (item: UxGoodsCardItemForVerticalProductCard, index: number) => {
    let server_log: Record<string, unknown> | undefined;

    if (item.log || selectedDrLogMap) {
      server_log = getServerLogForVerticalProductCard(item.catalog_product_id, item, selectedDrLogMap);
    }

    return {
      ...parentUbl,
      object_id: item.catalog_product_id ?? '',
      object_idx: index,
      data: {
        ...parentUbl.data,
        original_product_id,
        server_log,
      },
    };
  };

  const handleUBLImpression = (item: UxGoodsCardItemForVerticalProductCard, index: number) => {
    sendUbl({
      ...getChildUbl(item, index),
      category: 'impression',
    });
  };

  const handleUBLClick = (item: UxGoodsCardItemForVerticalProductCard, index: number) => {
    sendUbl({
      ...getChildUbl(item, index),
      category: 'click',
    });
  };

  const handleUBLLikeClick = (isLiked: boolean, item: UxGoodsCardItemForVerticalProductCard, index: number) => {
    sendUbl({
      ...getChildUbl(item, index),
      category: isLiked ? 'save_product' : 'remove_saved_product',
    });
  };

  return {
    getChildUbl,
    onUBLImpression: handleUBLImpression,
    onUBLClick: handleUBLClick,
    onUBLLikeClick: handleUBLLikeClick,
  };
}
